import { Box, TextButton } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { SPACING_SELECTOR_BUTTON } from "../../data-hooks";
const SpacingSelectorFooter = ({
  onOpenCustomEditor
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { align: "center" }, /* @__PURE__ */ React.createElement(
    TextButton,
    {
      dataHook: SPACING_SELECTOR_BUTTON,
      underline: "always",
      size: "small",
      onClick: onOpenCustomEditor
    },
    t("LineSpacing_customSpacing")
  ));
};
export {
  SpacingSelectorFooter
};
//# sourceMappingURL=spacing-selector-footer.js.map
